// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAoVivoRouteImport } from './routes/_authenticated/ao-vivo'
import { Route as AuthenticatedCalendarioRouteImport } from './routes/_authenticated/calendario'
import { Route as AuthenticatedFavoritosRouteImport } from './routes/_authenticated/favoritos'
import { Route as AuthenticatedInicioRouteImport } from './routes/_authenticated/inicio'
import { Route as AuthenticatedParashiotRouteImport } from './routes/_authenticated/parashiot'
import { Route as AuthenticatedStatusRouteImport } from './routes/_authenticated/status'
import { Route as AuthenticatedSuporteRouteImport } from './routes/_authenticated/suporte'
import { Route as AcessoConflitoEmailRouteImport } from './routes/acesso.conflito-email'
import { Route as SsoCallbackRouteImport } from './routes/sso.callback'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAdicionarRouteImport } from './routes/_authenticated/admin.adicionar'
import { Route as AuthenticatedAdminAprovacoesRouteImport } from './routes/_authenticated/admin.aprovacoes'
import { Route as AuthenticatedAdminComentariosRouteImport } from './routes/_authenticated/admin.comentarios'
import { Route as AuthenticatedAdminEmailDnsRouteImport } from './routes/_authenticated/admin.email-dns'
import { Route as AuthenticatedAdminEnsinosRouteImport } from './routes/_authenticated/admin.ensinos'
import { Route as AuthenticatedAdminIntegracaoRouteImport } from './routes/_authenticated/admin.integracao'
import { Route as AuthenticatedAdminIntegracaoLogsRouteImport } from './routes/_authenticated/admin.integracao-logs'
import { Route as AuthenticatedAdminLogsRouteImport } from './routes/_authenticated/admin.logs'
import { Route as AuthenticatedAdminMembrosRouteImport } from './routes/_authenticated/admin.membros'
import { Route as AuthenticatedAdminPainelRouteImport } from './routes/_authenticated/admin.painel'
import { Route as AuthenticatedAdminRegrasRouteImport } from './routes/_authenticated/admin.regras'
import { Route as AuthenticatedAdminSincronizarRouteImport } from './routes/_authenticated/admin.sincronizar'
import { Route as AuthenticatedAdminSyncStatusRouteImport } from './routes/_authenticated/admin.sync-status'
import { Route as AuthenticatedAdminYoutubeRouteImport } from './routes/_authenticated/admin.youtube'
import { Route as AuthenticatedEnsinosIndexRouteImport } from './routes/_authenticated/ensinos.index'
import { Route as AuthenticatedEnsinosIdRouteImport } from './routes/_authenticated/ensinos.$id'
import { Route as AuthenticatedParashiotIndexRouteImport } from './routes/_authenticated/parashiot.index'
import { Route as AuthenticatedParashiotSlugRouteImport } from './routes/_authenticated/parashiot.$slug'
import { Route as AuthenticatedPerfilIndexRouteImport } from './routes/_authenticated/perfil.index'
import { Route as AuthenticatedPerfilHistoricoRouteImport } from './routes/_authenticated/perfil.historico'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAoVivoRoute = AuthenticatedAoVivoRouteImport.update({
            id: '/ao-vivo',path: '/ao-vivo',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCalendarioRoute = AuthenticatedCalendarioRouteImport.update({
            id: '/calendario',path: '/calendario',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedFavoritosRoute = AuthenticatedFavoritosRouteImport.update({
            id: '/favoritos',path: '/favoritos',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInicioRoute = AuthenticatedInicioRouteImport.update({
            id: '/inicio',path: '/inicio',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedParashiotRoute = AuthenticatedParashiotRouteImport.update({
            id: '/parashiot',path: '/parashiot',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStatusRoute = AuthenticatedStatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSuporteRoute = AuthenticatedSuporteRouteImport.update({
            id: '/suporte',path: '/suporte',getParentRoute: () => AuthenticatedRouteRoute
          })
const AcessoConflitoEmailRoute = AcessoConflitoEmailRouteImport.update({
            id: '/acesso/conflito-email',path: '/acesso/conflito-email',getParentRoute: () => rootRouteImport
          })
const SsoCallbackRoute = SsoCallbackRouteImport.update({
            id: '/sso/callback',path: '/sso/callback',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAdicionarRoute = AuthenticatedAdminAdicionarRouteImport.update({
            id: '/adicionar',path: '/adicionar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAprovacoesRoute = AuthenticatedAdminAprovacoesRouteImport.update({
            id: '/aprovacoes',path: '/aprovacoes',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminComentariosRoute = AuthenticatedAdminComentariosRouteImport.update({
            id: '/comentarios',path: '/comentarios',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailDnsRoute = AuthenticatedAdminEmailDnsRouteImport.update({
            id: '/email-dns',path: '/email-dns',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEnsinosRoute = AuthenticatedAdminEnsinosRouteImport.update({
            id: '/ensinos',path: '/ensinos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIntegracaoRoute = AuthenticatedAdminIntegracaoRouteImport.update({
            id: '/integracao',path: '/integracao',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIntegracaoLogsRoute = AuthenticatedAdminIntegracaoLogsRouteImport.update({
            id: '/integracao-logs',path: '/integracao-logs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLogsRoute = AuthenticatedAdminLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMembrosRoute = AuthenticatedAdminMembrosRouteImport.update({
            id: '/membros',path: '/membros',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPainelRoute = AuthenticatedAdminPainelRouteImport.update({
            id: '/painel',path: '/painel',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminRegrasRoute = AuthenticatedAdminRegrasRouteImport.update({
            id: '/regras',path: '/regras',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSincronizarRoute = AuthenticatedAdminSincronizarRouteImport.update({
            id: '/sincronizar',path: '/sincronizar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSyncStatusRoute = AuthenticatedAdminSyncStatusRouteImport.update({
            id: '/sync-status',path: '/sync-status',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminYoutubeRoute = AuthenticatedAdminYoutubeRouteImport.update({
            id: '/youtube',path: '/youtube',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedEnsinosIndexRoute = AuthenticatedEnsinosIndexRouteImport.update({
            id: '/ensinos/',path: '/ensinos/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedEnsinosIdRoute = AuthenticatedEnsinosIdRouteImport.update({
            id: '/ensinos/$id',path: '/ensinos/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedParashiotIndexRoute = AuthenticatedParashiotIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedParashiotRoute
          })
const AuthenticatedParashiotSlugRoute = AuthenticatedParashiotSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AuthenticatedParashiotRoute
          })
const AuthenticatedPerfilIndexRoute = AuthenticatedPerfilIndexRouteImport.update({
            id: '/perfil/',path: '/perfil/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPerfilHistoricoRoute = AuthenticatedPerfilHistoricoRouteImport.update({
            id: '/perfil/historico',path: '/perfil/historico',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAdicionarRoute: AuthenticatedAdminAdicionarRoute,AuthenticatedAdminAprovacoesRoute: AuthenticatedAdminAprovacoesRoute,AuthenticatedAdminComentariosRoute: AuthenticatedAdminComentariosRoute,AuthenticatedAdminEmailDnsRoute: AuthenticatedAdminEmailDnsRoute,AuthenticatedAdminEnsinosRoute: AuthenticatedAdminEnsinosRoute,AuthenticatedAdminIntegracaoRoute: AuthenticatedAdminIntegracaoRoute,AuthenticatedAdminIntegracaoLogsRoute: AuthenticatedAdminIntegracaoLogsRoute,AuthenticatedAdminLogsRoute: AuthenticatedAdminLogsRoute,AuthenticatedAdminMembrosRoute: AuthenticatedAdminMembrosRoute,AuthenticatedAdminPainelRoute: AuthenticatedAdminPainelRoute,AuthenticatedAdminRegrasRoute: AuthenticatedAdminRegrasRoute,AuthenticatedAdminSincronizarRoute: AuthenticatedAdminSincronizarRoute,AuthenticatedAdminSyncStatusRoute: AuthenticatedAdminSyncStatusRoute,AuthenticatedAdminYoutubeRoute: AuthenticatedAdminYoutubeRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedParashiotRouteChildren = {
  AuthenticatedParashiotSlugRoute: AuthenticatedParashiotSlugRoute,AuthenticatedParashiotIndexRoute: AuthenticatedParashiotIndexRoute
}

const AuthenticatedParashiotRouteWithChildren = AuthenticatedParashiotRoute._addFileChildren(AuthenticatedParashiotRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedAoVivoRoute: AuthenticatedAoVivoRoute,AuthenticatedCalendarioRoute: AuthenticatedCalendarioRoute,AuthenticatedFavoritosRoute: AuthenticatedFavoritosRoute,AuthenticatedInicioRoute: AuthenticatedInicioRoute,AuthenticatedParashiotRoute: AuthenticatedParashiotRouteWithChildren,AuthenticatedStatusRoute: AuthenticatedStatusRoute,AuthenticatedSuporteRoute: AuthenticatedSuporteRoute,AuthenticatedEnsinosIdRoute: AuthenticatedEnsinosIdRoute,AuthenticatedPerfilHistoricoRoute: AuthenticatedPerfilHistoricoRoute,AuthenticatedEnsinosIndexRoute: AuthenticatedEnsinosIndexRoute,AuthenticatedPerfilIndexRoute: AuthenticatedPerfilIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,PrivacidadeRoute: PrivacidadeRoute,TermosRoute: TermosRoute,AcessoConflitoEmailRoute: AcessoConflitoEmailRoute,SsoCallbackRoute: SsoCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)